export const PDF_TABLE_GAP = 8;
export const PDF_TABLE_CDT_WIDTH = 80;
export const PDF_TABLE_TOOTH_WIDTH = 45;
export const PDF_TABLE_SURFACE_WIDTH = 45;
export const PDF_TABLE_FEE_WIDTH = 60;
export const PDF_ROW_PADDING = 8;
export const PDF_PAGE_CONTENT_WIDTH = 595.28 - 30 * 2;
export const PDF_ROW_INNER_WIDTH =
  PDF_PAGE_CONTENT_WIDTH - PDF_ROW_PADDING * 2;
export const PDF_TABLE_NAME_WIDTH =
  PDF_ROW_INNER_WIDTH -
  PDF_TABLE_CDT_WIDTH -
  PDF_TABLE_TOOTH_WIDTH -
  PDF_TABLE_SURFACE_WIDTH -
  PDF_TABLE_FEE_WIDTH -
  PDF_TABLE_GAP * 4;
export const PDF_APPOINTMENT_META_GAP = 8;
export const PDF_APPOINTMENT_NUMBER_WIDTH = 18;
export const PDF_APPOINTMENT_META_WIDTH = 90;
export const PDF_APPOINTMENT_NAME_WIDTH =
  PDF_ROW_INNER_WIDTH -
  PDF_APPOINTMENT_NUMBER_WIDTH -
  PDF_APPOINTMENT_META_WIDTH -
  PDF_TABLE_FEE_WIDTH -
  PDF_APPOINTMENT_META_GAP * 3;

export const pdfColors = {
  primary: "#3A8AB9",
  dark: "#0E426D",
  text: "#1B252F",
  secondary: "#6B7A94",
  background: "#F5F9FD",
  mediumBlue: "#E8F6F9",
  lightBlue: "#E3F2FD",
  border: "#B9CED5",
  white: "#FFFFFF",
  action: "#3A8AB9",
  link: "#0E426D",
};
